import React from 'react'

const ErrorPage = () => {
  return (
    <div className='text-dark mt-5 text-center'>ErrorPage</div>
  )
}

export default ErrorPage